// export const base_path = process.env.REACT_APP_BASE_PATH


export const base_path = "/"; 




export const img_path ='/'